import React, { Component, PropTypes} from 'react'
import CSSModules from 'react-css-modules'
import { LinkIcon } from '../../components'
import config from '../../config'
import format from '../../helpers/format'
import convert from '../../helpers/convert'
import ReactTooltip from 'react-tooltip'

import Styles from './GenderEqualityScoreLabel.css'

const NULL_SENTINEL = -1.0

@CSSModules(Styles,{allowMultiple:true})
export default class GenderEqualityScoreLabel extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    gefType: PropTypes.string.isRequired,
    xsmall: PropTypes.bool
  }
  constructor(props){
    super(props)
  }
  render() {
    const scoreStyle = (__score) => {
      const _score = convert.float(__score)
      if (_score < 10) {
        return 'percentile-10'
      } else if (_score < 20) {
        return 'percentile-20'
      } else if (_score < 30) {
        return 'percentile-30'
      } else if (_score < 40) {
        return 'percentile-40'
      } else if (_score < 50) {
        return 'percentile-50'
      } else if (_score < 60) {
        return 'percentile-60'
      } else if (_score < 70) {
        return 'percentile-70'
      } else if (_score < 80) {
        return 'percentile-80'
      } else if (_score < 90) {
        return 'percentile-90'
      } else if (_score <= 100) {
        return 'percentile-100'
      }
      return false
    }

    // assign score values
    // assign tooltips
    const fund = this.props.fund
    const gefType = this.props.gefType
    const _id = fund.investment_vehicle_id || fund.fund_id

    const scoreValue = fund[gefType]
    const notEmpty = convert.float(scoreValue) > NULL_SENTINEL

    let score = null
    let norm = null
    let tip = null
    let emptyTip = null
    let units = null
    let nth = null

    const _div = "<div style='max-width:200px;font-weight:300;'>"
    const div_ = '</div>'

    const emptyScoreTip = "None of this fund's holdings were scored by Equileap, so we can't calculate a score"
    const emptyRankTip = "Less than 1/3 of this fund's holdings were scored by Equileap. When the score coverage is below 33%, we remove the fund from our rankings to increase accuracy"

    switch(gefType) {
      case 'gef_score':
        score = format.gefScore(scoreValue)
        tip = `Earned an overall gender-lens score of ${score} out of 100`
        emptyTip = emptyScoreTip
        units = ' / 100 points'
        break
      case 'gef_score_a':
        norm = config.gefScoreNormalizers.balance
        score = format.gefScore(scoreValue, norm)
        tip = `Earned a gender balance score of ${score} out of 100`
        emptyTip = emptyScoreTip
        units = ' / 100 points'
        break
      case 'gef_score_b':
        norm = config.gefScoreNormalizers.policies
        score = format.gefScore(scoreValue, norm)
        tip = `Earned a gender policies score of ${score} out of 100`
        emptyTip = emptyScoreTip
        units = ' / 100 points'
        break
      case 'gef_rank':
        norm = config.gefScoreNormalizers.allScored
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of all ${format.number(norm)} funds analyzed scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_rank_a':
        norm = config.gefScoreNormalizers.allScored
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of all ${format.number(norm)} funds analyzed scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_rank_b':
        norm = config.gefScoreNormalizers.allScored
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of all ${format.number(norm)} funds analyzed scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_peer':
        norm = config.gefScoreNormalizers.peers[fund.morningstar_category_name]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.morningstar_category_name} category scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_peer_a':
        norm = config.gefScoreNormalizers.peers[fund.morningstar_category_name]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.morningstar_category_name} category scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_peer_b':
        norm = config.gefScoreNormalizers.peers[fund.morningstar_category_name]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.morningstar_category_name} category scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_grp':
        norm = config.gefScoreNormalizers.groups[fund.category_group]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.category_group} group scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_grp_a':
        norm = config.gefScoreNormalizers.groups[fund.category_group]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.category_group} group scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      case 'gef_grp_b':
        norm = config.gefScoreNormalizers.groups[fund.category_group]
        score = format.gefScore(scoreValue, norm, 0, 1)
        tip = `${score} % of ${format.number(norm)} funds in the ${fund.category_group} group scored the same or lower`
        emptyTip = emptyRankTip
        units = 'percentile'
        nth = format.ordinalSuffix(score)
        break
      default:
        score = null
        tip = null
        emptyTip = null
    }

    score = format.dropStringTrailingZero(score)

    if (notEmpty === true && score !== null) {
      let stylNm = scoreStyle(score)
      stylNm = (units !== 'percentile') ? (stylNm + '-border') : stylNm
      stylNm = (this.props.xsmall) ? (stylNm + '-small') : stylNm
      return (
        <span
          styleName={stylNm}
          data-multiline={true}
          data-effect='solid'
          data-place='bottom'
          data-for={gefType + '-' + _id}
          data-html={true}
          data-tip={_div + tip + div_}
        >
          {score}{(nth) ? (<sup><small>{nth}</small></sup>) : null}&nbsp;<small>{units}</small>
          <ReactTooltip id={gefType + '-' + _id}/>
        </span>
      )
    } else {
      return (
        <span
          styleName='no-score'
          data-multiline={true}
          data-effect='solid'
          data-place='bottom'
          data-for={'empty-' + gefType + '-' + _id}
          data-html={true}
          data-tip={_div + emptyTip + div_}
        >
          <LinkIcon nospace={true} faclass='fa-ban'/>
          &nbsp;
          { (emptyTip === emptyScoreTip)
            ? 'Unscored'
            : 'Unranked' }
          <ReactTooltip id={'empty-' + gefType + '-' + _id}/>
        </span>
      )
    }
  }
}
